<style lang="sass" scoped>
@import '../../../../css/core';

.form-group.required .control-label:after {
  content: '*';
  color: red;
}

#scalpProtectiveAgentControlLabel {
  padding-right: 20px;
}

#scalpProtectiveAgentNoUseLabel,
#scalpProtectiveAgentUseLabel,
#scalpProtectiveAgentMoreUseLabel {
  padding-left: 5px;
  padding-right: 20px;
}

.span-solution:before {
  content: "";
  white-space: pre;
  word-wrap: break-word;
  display: block;
}

.historyInputShade {
	position: fixed;
  width: 100%;
  height: calc(100% - 105px - 250px);
  left: 0;
  top: calc(105px + 250px);
	background-color: rgba(0,0,0,0.5);
  z-index: 99;
  text-align: center;
  color: rgb(255, 181, 0);
  font-size: 30px;
  padding-top: 200px;
}

#treatmentControllLabel {
  padding-right: 20px;
}

#treatmentNothingLabel,
#treatmentRustleLabel,
#treatmentGlossyLabel,
#treatmentElasticityLabel {
  padding-left: 5px;
  padding-right: 20px;
}

.hotpepper-point {
  font-size: 32px;
}

.available-staff {
  background-color: #a5ff91;
}

.unavailable-staff {
  background-color: #c1baba;
}

.invalid-responding-staff {
  background-color: #ff9393;
}

</style>

<template>
<div id="modal-form-edit" v-bind:style="{'display': display ? '' : 'none'}">
  <div class="modal-header">
    <span v-show="historyInputEnable" class="glyphicon glyphicon-user" area-hidden="true"></span>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <div v-if="errorResponse" class="alert alert-danger" role="alert">
      <ul>
        <li v-for="e in nonFieldErrors">{{ e }}</li>
        <li v-for="errors in fieldErrors" v-if="errors.length">
          {{ formLabels[$key] }}
          <ul>
            <li v-for="e in errors">{{ e }}</li>
          </ul>
        </li>
      </ul>
    </div>
    <tabset :active.sync="activeTab">
      <tab header="予約情報">
        <div class="row">
          <div class="col-sm-12">
            <h4>予約情報
              <small class="pull-right">
                <span v-show="createdAt" class="text-right">受付日時: {{ createdAtStr }}</span>
              </small>
            </h4>
            <hr>
          </div>
          <div class="col-sm-6">
            <div class="form-group form-group-sm required"
                 v-bind:class="{'has-error': fieldErrors.startAt.length}">
              <label class="control-label">{{ formLabels['startAt'] }}</label>
              <div class="form-inline">
                <datepicker
                    :disabled="restrictReserveTime"
                    :value.sync="startDate"
                    date-format="YYYY-MM-DD (dd)"
                    :width="150"
                ></datepicker>
                <timepicker
                    :disabled="restrictReserveTime"
                    :value.sync="startTime"
                    :start-at="openTime"
                    :step-in-minutes="10"
                    :end-at="closeTime"
                ></timepicker>
              </div>
            </div>
            <div class="form-group form-group-sm required"
                 v-bind:class="{'has-error': fieldErrors.status.length}">
              <label class="control-label" for="status-{{ _uid }}">{{ formLabels['status'] }}</label>
              <select id="status-{{ _uid }}" class="form-control" v-model="status">
                <option v-for="(value, text) in statusOptions" :value="value" :selected="">{{ text }}</option>
              </select>
            </div>
            <div class="form-group form-group-sm required"
                 v-bind:class="{'has-error': fieldErrors.menu.length || fieldErrors.menuOptions.length}">
              <label class="control-label" for="menu-{{ _uid }}">{{ formLabels['menu'] }}</label>
              <select id="menu-{{ _uid }}" class="form-control" :disabled="restrictReserveTime" v-model="menu" @change="menuOptions = []">
                <option></option>
                <option v-for="m in menus" :value="m">{{ m.name }}</option>
              </select>
              <template v-if="menu">
              <div v-for="o in menu._embedded.options" class="checkbox">
                  <input type="checkbox" :disabled="restrictReserveTime" :value="o" style="margin-left: 20px;" v-model="menuOptions">
                  <label style="heigth: 40px; padding-top: 12px; margin-left: 22px;">{{ o.name }}</label>
              </div>
              </template>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group form-group-sm required"
                 v-bind:class="{'has-error': fieldErrors.reservedBy.length}">
              <label class="control-label" for="reserved-by-{{ _uid }}">{{ formLabels['reservedBy'] }}</label>
              <select id="reserved-by-{{ _uid }}" class="form-control" v-model="reservedBy">
                <option></option>
                <option v-for="(value, text) in reservedByOptions" :value="value">{{ text }}</option>
              </select>
            </div>
            <div class="form-group form-group-sm"
                 v-bind:class="{'has-error': fieldErrors.attendedStaff.length, 'required': reservedBy == reservedByMaster.PHONE || reservedBy == reservedByMaster.REPEAT }">
              <label class="control-label" for="attended-staff-{{ _uid }}">{{ formLabels['attendedStaff'] }}</label>
              <select id="attended-staff-{{ _uid }}" class="form-control" v-model="attendedStaff">
                <option></option>
                <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
              </select>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.respondingStaff.length}">
              <label class="control-label" for="responding-staff-{{ _uid }}">{{ formLabels['respondingStaff'] }}</label>
              <select id="responding-staff-{{ _uid }}" class="form-control" v-model="respondingStaff" :class="{'invalid-responding-staff': !isAvailableStaff && shop.inExperiment}">
                <option></option>
                <template v-if="shop.inExperiment">
                <optgroup v-if="availableStaffs.length" label="対応すべきスタッフ">
                  <option v-for="s in availableStaffs" :value="s" class="available-staff">{{ s.name }} ({{ s.shopName }})</option>
                </optgroup>
                <optgroup v-if="unavailableStaffs.length" label="対応すべきでないスタッフ">
                  <option v-for="s in unavailableStaffs" :value="s" class="unavailable-staff">{{ s.name }} ({{ s.shopName }})</option>
                </optgroup>
                </template>
                <template v-else>
                  <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
                </template>
              </select>
            </div>
            <div v-show="shop.inExperiment" class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.respondingShampooStaff.length}">
              <label class="control-label" for="responding-shampoo-staff-{{ _uid }}">{{ formLabels['respondingShampooStaff'] }}</label>
              <select id="responding-shampoo-staff-{{ _uid }}" class="form-control" v-model="respondingShampooStaff">
                <option></option>
                <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
              </select>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.note.length}">
              <label class="control-label" for="note-{{ _uid }}">{{ formLabels['note'] }}</label>
              <textarea id="note-{{ _uid }}" class="form-control" rows="3" v-model="note"></textarea>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.isRepeatInMonth.length}">
              <div class="checkbox" style="padding-left: 20px;">
                <input id="in-month-{{ _uid }}" type="checkbox" v-model="isRepeatInMonth"><label class="control-label" style="heigth: 40px; padding-top: 12px; padding-left: 2px;" for="in-month-{{ _uid }}">45日以内の再来店</label>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <p v-if="hotpepperReservationNo" class="form-control-static">ホットペッパー予約番号: {{ hotpepperReservationNo }}</p>
              <p v-if="hotpepperPoint" class="form-control-static">
                ホットペッパーポイント利用: <strong class="text-danger hotpepper-point">{{ hotpepperPoint + 'pt' }}</strong>
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <h4>お客さま情報 (<a href="#" @click.prevent="findCustomer">検索</a>)</h4>
            <hr>
          </div>
          <div class="col-sm-6">
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.account.length}">
              <label class="control-label" for="customer-id-{{ _uid }}">{{ formLabels['account'] }}</label>
              <div class="form-inline">
                <select id="customer-id-prefix-{{ _uid }}" type="text" class="form-control" v-model="shortAccountPrefix">
                  <option v-for="obj in shopsWithoutGroup" value="{{ obj.code }}">{{ obj.name }} ({{ obj.code }})</option>
                </select>
                <input id="customer-id-{{ _uid }}" type="text" class="form-control" v-model="shortAccount">
              </div>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.phoneNumber.length}">
              <label class="control-label" for="phone-number-{{ _uid }}">{{ formLabels['phoneNumber'] }}</label>
              <input id="phone-number-{{ _uid }}" type="text" class="form-control" v-model="phoneNumber">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group form-group-sm required" v-bind:class="{'has-error': fieldErrors.familyNameKana.length || fieldErrors.firstNameKana.length}">
              <label class="control-label">{{ formLabels['nameKana'] }}</label>
              <div class="form-inline">
                <input type="text" class="form-control" v-model="familyNameKanaInput" placeholder="{{ formLabels['familyNameKana'] }}">
                <input type="text" class="form-control" v-model="firstNameKanaInput" placeholder="{{ formLabels['firstNameKana'] }}">
              </div>
            </div>
            <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.familyName.length || fieldErrors.firstName.length}">
              <label class="control-label">{{ formLabels['name'] }}</label>
              <div class="form-inline">
                <input type="text" class="form-control" v-model="familyName" placeholder="{{ formLabels['familyName'] }}">
                <input type="text" class="form-control" v-model="firstName" placeholder="{{ formLabels['firstName'] }}">
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab header="施術履歴">
        <div>
          <div>
            <div class="row">
              <div class="col-sm-12">
                <h4>お客さま情報 <small v-show="!historyInputEnable">(<a href="#" @click.prevent="findCustomer">検索</a>)</small></h4>
                <hr>
              </div>
              <div v-show="!historyInputEnable" class="col-sm-6">
                <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.account.length}">
                  <label class="control-label" for="customer-id-{{ _uid }}">{{ formLabels['account'] }}</label>
                  <div class="form-inline">
                    <select id="customer-id-prefix-{{ _uid }}" type="text" class="form-control" v-model="shortAccountPrefix">
                      <option v-for="obj in shopsWithoutGroup" value="{{ obj.code }}">{{ obj.name }} ({{ obj.code }})</option>
                    </select>
                    <input id="customer-id-{{ _uid }}" type="text" class="form-control" v-model="shortAccount">
                  </div>
                </div>
                <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.phoneNumber.length}">
                  <label class="control-label" for="phone-number-{{ _uid }}">{{ formLabels['phoneNumber'] }}</label>
                  <input id="phone-number-{{ _uid }}" type="text" class="form-control" v-model="phoneNumber">
                </div>
              </div>
              <div v-show="!historyInputEnable" class="col-sm-6">
                <div class="form-group form-group-sm" v-bind:class="{'has-error': fieldErrors.familyNameKana.length || fieldErrors.firstNameKana.length}">
                  <label class="control-label">{{ formLabels['nameKana'] }}</label>
                  <div class="form-inline">
                    <input type="text" class="form-control" v-model="familyNameKanaInput" placeholder="{{ formLabels['familyNameKana'] }}">
                    <input type="text" class="form-control" v-model="firstNameKanaInput" placeholder="{{ formLabels['firstNameKana'] }}">
                  </div>
                </div>
              </div>
              <div v-show="historyInputEnable" class="row">
                <div class="col-sm-4 text-center">
                  お客さま番号:<span>{{ shortAccountPrefixShopName }}({{ shortAccountPrefix }}) - {{ shortAccount }}</span>
                </div>
                <div class="col-sm-4 text-center">
                  お客さま氏名（カナ）:
                  <span>{{ familyNameKana }} {{ firstNameKana }}</span>
                </div>
                <div class="col-sm-4 text-center">
                  お客さま氏名:
                  {{ familyName }} {{ firstName }}
                </div>
              </div>
            </div>
          </div>
          <div v-show="!historyInputEnable" class="historyInputShade">お客さま情報を検索し、<br>施術履歴を入力するお客さまを選んでください。</div>
          <div class="row">
            <div class="col-sm-12">
              <hr>
            </div>
            <div class="col-sm-4 text-center">
              <div class="form-group form-group-sm form-inline"
                   v-bind:class="{'has-error': fieldErrors.treatmentStaff.length}">
                <span>{{ formLabels['treatmentStaff'] }}</span>
                <select id="treatment-staff-{{ _uid }}" class="form-control" v-model="treatmentStaff">
                  <option></option>
                  <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
                </select>
              </div>
              <!--
              <div class="form-group form-group-sm form-inline"
                   v-bind:class="{'has-error': fieldErrors.counselingStaff.length}">
                <span>{{ formLabels['counselingStaff'] }}</span>
                <select id="counseling-staff-{{ _uid }}" class="form-control" v-model="counselingStaff">
                  <option></option>
                  <option v-for="s in sortedStaffs" :value="s">{{ s.name }}</option>
                </select>
              </div>
              -->
            </div>
            <div class="col-sm-4 text-center">
              <div class="form-group form-group-sm form-inline"
                   v-bind:class="{'has-error': fieldErrors.dyeingStaff_1.length}">
                <span>{{ formLabels['dyeingStaff_1'] }}</span>
                <select id="dyeing-staff-1-{{ _uid }}" class="form-control" v-model="dyeingStaff_1">
                  <option></option>
                  <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
                </select>
              </div>
              <div class="form-group form-group-sm form-inline"
                   v-bind:class="{'has-error': fieldErrors.dyeingStaff_2.length}">
                <span>{{ formLabels['dyeingStaff_2'] }}</span>
                <select id="dyeing-staff-2-{{ _uid }}" class="form-control" v-model="dyeingStaff_2">
                  <option></option>
                  <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4 text-center">
              <div class="form-group form-group-sm form-inline"
                   v-bind:class="{'has-error': fieldErrors.shampooStaff.length}">
                <span>{{ formLabels['shampooStaff'] }}</span>
                <select id="shampoo-staff-{{ _uid }}" class="form-control" v-model="shampooStaff">
                  <option></option>
                  <option v-for="s in sortedStaffs" :value="s">{{ s.name }} ({{ s.shopName }})</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div v-if="lastOperationHistory" class="form-group form-group-sm">
                <button class="btn btn-default" @click="copyLastUsedDyestuffs">前回の使用染料をコピーする</button>
              </div>
            </div>
            <div class="col-sm-9">
              <div class="form-group form-inline form-group-sm">
                <span>根元</span><br>
                <span>1剤 :</span>
                <template v-for="usedDyestuff in usedDyestuffsForRoots" track-by="$index">
                  <div class="input-group">
                    <select
                        class="form-control"
                        v-select="usedDyestuffsForRoots[$index]['dyestuff']"
                        :data="dyestuffOptions"
                        placeholder="染料"
                        style="width: 140px"
                    ></select>
                  </div>
                  <div class="input-group" style="margin-right: 5px">
                    <input
                      type="text"
                      class="form-control"
                      style="width: 50px"
                      v-model="usedDyestuffsForRoots[$index]['amount']"
                      @change="checkDigit(usedDyestuffsForRoots, $index)"
                      @blur="checkOver(usedDyestuffsForRoots, $index)"
                    >
                    <div class="input-group-addon">g</div>
                  </div>
                </template>
                <a v-if="usedDyestuffsForRoots.length > 1"
                   @click="usedDyestuffsForRoots.pop()"
                   class="btn btn-default"
                >-</a>
                <a @click="usedDyestuffsForRoots.push(defaultUsedDyestuff())"
                   class="btn btn-default"
                >+</a>
              </div>
              <div class="form-group form-inline form-group-sm">
                <span>2剤 :</span>
                <template v-for="usedSolution in usedSolutionsForRoots" track-by="$index">
                  <div class="input-group" style="margin-right: 5px">
                    <select
                        type="text"
                        class="form-control"
                        style="width: 60px"
                        v-model="usedSolutionsForRoots[$index]['percentage']"
                    >
                      <option value=""></option>
                      <option v-for="n in 6" value="{{ n + 1 }}">{{ n + 1}}</option>
                    </select>
                    <div class="input-group-addon">%</div>
                  </div>
                  <div class="input-group" style="margin-right: 5px">
                    <input
                      type="text"
                      class="form-control"
                      style="width: 50px"
                      v-model="usedSolutionsForRoots[$index]['amount']"
                      @change="checkDigit(usedSolutionsForRoots, $index)"
                      @blur="checkOver(usedSolutionsForRoots, $index)"
                    >
                    <div class="input-group-addon">g</div>
                  </div>
                </template>
                <a v-if="usedSolutionsForRoots.length > 1"
                   @click="usedSolutionsForRoots.pop()"
                   class="btn btn-default"
                >-</a>
                <a @click="usedSolutionsForRoots.push(defaultUsedSolution())"
                   class="btn btn-default"
                >+</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-9">
              <div class="form-group form-inline form-group-sm">
                <span>毛先</span><br>
                <span>1剤 :</span>
                <template v-for="usedDyestuff in usedDyestuffsForEnds" track-by="$index">
                  <div class="input-group">
                    <select
                      class="form-control"
                      v-select="usedDyestuffsForEnds[$index]['dyestuff']"
                      :data="dyestuffOptions"
                      placeholder="染料"
                      style="width: 140px"
                    ></select>
                  </div>
                  <div class="input-group" style="margin-right: 5px">
                    <input
                      type="text"
                      class="form-control"
                      style="width: 50px"
                      v-model="usedDyestuffsForEnds[$index]['amount']"
                      @change="checkDigit(usedDyestuffsForEnds, $index)"
                      @blur="checkOver(usedDyestuffsForEnds, $index)"
                    >
                    <div class="input-group-addon">g</div>
                  </div>
                </template>
                <a v-if="usedDyestuffsForEnds.length > 1"
                   @click="usedDyestuffsForEnds.pop()"
                   class="btn btn-default"
                >-</a>
                <a @click="usedDyestuffsForEnds.push(defaultUsedDyestuff())"
                   class="btn btn-default"
                >+</a>
              </div>
              <div class="form-group form-inline form-group-sm">
                <span>2剤 :</span>
                <template v-for="usedSolution in usedSolutionsForEnds" track-by="$index">
                  <div class="input-group" style="margin-right: 5px">
                    <select
                      type="text"
                      class="form-control"
                      style="width: 60px"
                      v-model="usedSolutionsForEnds[$index]['percentage']"
                    >
                      <option value=""></option>
                      <option v-for="n in 6" value="{{ n + 1 }}">{{ n + 1}}</option>
                    </select>
                    <div class="input-group-addon">%</div>
                  </div>
                  <div class="input-group" style="margin-right: 5px">
                    <input
                      type="text"
                      class="form-control"
                      style="width: 50px"
                      v-model="usedSolutionsForEnds[$index]['amount']"
                      @change="checkDigit(usedSolutionsForEnds, $index)"
                      @blur="checkOver(usedDyestuffsForEnds, $index)"
                    >
                    <div class="input-group-addon">g</div>
                  </div>
                </template>
                <a v-if="usedSolutionsForEnds.length > 1"
                   @click="usedSolutionsForEnds.pop()"
                   class="btn btn-default"
                >-</a>
                <a @click="usedSolutionsForEnds.push(defaultUsedSolution())"
                   class="btn btn-default"
                >+</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="input-group form-group-sm">
                <label class="control-label" id="scalpProtectiveAgentControlLabel">頭皮保護剤 :</label>
                <input type="radio" v-model="scalpProtectiveAgent" value="0" id="scalpProtectiveAgentNoUse">
                <label for="scalpProtectiveAgentNoUse" id="scalpProtectiveAgentNoUseLabel">使っていない</label> 
                <input type="radio" v-model="scalpProtectiveAgent" value="1" id="scalpProtectiveAgentUse">
                <label for="scalpProtectiveAgentUse" id="scalpProtectiveAgentUseLabel">使った</label> 
                <input type="radio" v-model="scalpProtectiveAgent" value="2" id="scalpProtectiveAgentMoreUse">
                <label for="scalpProtectiveAgentMoreUse" id="scalpProtectiveAgentMoreUseLabel">たくさん使った</label> 
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="input-group form-group-sm" class="treatment">
                <label class="control-label" id="treatmentControllLabel">トリートメント:</label>
                <input type="radio" v-model="treatment" value="0" id="treatmentNothing">
                <label for="treatmentNothing" id="treatmentNothingLabel">していない</label>
                <input type="radio" v-model="treatment" value="1" id="treatmentRustle">
                <label for="treatmentRustle" id="treatmentRustleLabel">さらさら</label>
                <input type="radio" v-model="treatment" value="2" id="treatmentGlossy">
                <label for="treatmentGlossy" id="treatmentGlossyLabel">つやさら</label>
                <input type="radio" v-model="treatment" value="4" id="treatmentColorCare">
                <label for="treatmentColorCare" id="treatmentColorCare">カラーケア</label>
                <input type="radio" v-model="treatment" value="3" id="treatmentElasticity">
                <label for="treatmentElasticity" id="treatmentElasticityLabel">つやコシ</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group form-group-sm">
                <label class="control-label">メモ</label>
                <textarea class="form-control" rows="3" v-model="operationNote"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <table class="table">
                <thead>
                <tr>
                  <th>施術日</th>
                  <th>使用染料(根元)</th>
                  <th>使用染料(毛先)</th>
                  <th>保護剤</th>
                  <th>トリートメント</th>
                  <th>施術</th>
                  <th>塗布1</th>
                  <th>塗布2</th>
                  <th>シャンプー</th>
                  <th>メモ</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="history in operationHistories">
                    <td>{{ history.date }}</td>
                    <td>
                      <span v-if="history.usedDyestuffsForRoots.length > 0">
                        1剤:{{ displayUsedDyestuffs(history.usedDyestuffsForRoots) }}
                      </span>
                      <span class="span-solution" v-if="history.usedSolutionsForRoots.length > 0">
                        2剤:{{ displayUsedSolutions(history.usedSolutionsForRoots) }}
                      </span>
                    </td>
                    <td>
                      <span v-if="history.usedDyestuffsForEnds.length > 0">
                        1剤:{{ displayUsedDyestuffs(history.usedDyestuffsForEnds) }}
                      </span>
                      <span class="span-solution" v-if="history.usedSolutionsForEnds.length > 0">
                        2剤:{{ displayUsedSolutions(history.usedSolutionsForEnds) }}
                      </span>
                    </td>
                    <td>
                      <span>{{ displayScalpProtectiveAgent(history.scalpProtectiveAgent) }}</span>
                    </td>
                    <td>
                      <span>{{ displayTreatment(history.treatment) }}</span>
                    </td>
                    <td>
                      {{ history.treatmentStaffName|blankHyphen }}
                    </td>
                    <td>
                      {{ history.dyeingStaff_1_name|blankHyphen }}
                    </td>
                    <td>
                      {{ history.dyeingStaff_2_name|blankHyphen }}
                    </td>
                    <td>
                      {{ history.shampooStaffName|blankHyphen }}
                    </td>
                    <td>{{ history.note }}</td>
                    <td>
                      <button @click="deleteOperationHistory(history.pk)" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </td>
                  </tr>
                  <tr v-for="history in sortedOldOperationHistories">
                    <td>{{ history.date }}</td>
                    <td>{{ history.usedDyestuffsForRoots }}</td>
                    <td>{{ history.usedDyestuffsForEnds }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>{{ history.chargeStaffName }}</td>
                    <td>{{ history.dyeingStaff_1_name|blankHyphen }}</td>
                    <td>{{ history.dyeingStaff_2_name|blankHyphen }}</td>
                    <td>{{ history.shampooStaffName }}</td>
                    <td>{{ history.memo }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </tab>
      <tab header="お客さまメモ">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group form-group-sm">
              <label class="control-label">お客さまメモ</label>
              <textarea class="form-control" rows="3" v-model="customerNote"></textarea>
            </div>
          </div>
        </div>
      </tab>
    </tabset>
  </div>
  <div class="modal-footer">
    <button v-if="reservationPk && !isRemoved" class="btn btn-danger pull-left" @click="remove">削除</button>
    <button v-if="isRemoved" class="btn btn-success pull-left" :disabled="isSending" @click="restore">復元</button>

    <button class="btn btn-warning" @click="changeTime" v-if="restrictReserveTime">予約時間／メニューを変更</button>
    <button class="btn btn-primary" :disabled="isSending" @click="submit()" v-text="reservationPk ? '更新': '登録'"></button>
  </div>
</div>
</template>


<script lang="babel">
import moment from 'moment'
import ReservationStatus from 'ReservationStatus'
import ReservedBy from 'ReservedBy'
import { getAccount } from 'getters'

export default {
  name: 'reservation-table-modal-form-edit',
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    shop: {
      type: Object,
      required: true,
    },
    shops: {
      type: Array,
      required: true,
    },
    staffs: {
      type: Array,
      required: true,
    },
    availabilities: {
      type: Array,
      required: true,
    },
    menus: {
      type: Array,
      required: true,
    },
    dyestuffs: {
      type: Array,
      required: true,
    },
    businessHour: {
      type: Object,
      required: true,
    },
  },
  events: {
    'prepare-create': function (createAt) {
      this.reset()
      this.startAt = createAt
      this.menu = this.menus.find(x => x.name === 'リタッチ')
    },
    'time-select': function (startAt, menu, menuOptions) {
      this.startAt = startAt
      this.menu = menu
      this.menuOptions = menuOptions
    },
    'prepare-update': function (reservation) {
      this.reset()
      this.assignReservation(reservation)
      this.fetchOperationHistories(reservation.customer.crmUuid)
    },
    'edit-select-customer': function (options) {
      this.account = options.customer.account
      this.shortAccountPrefix = options.customer.shopCode
      this.crmUuid = options.customer.uuid
      this.phoneNumber = options.customer.phoneNumber
      this.familyName = options.customer.familyName
      this.firstName = options.customer.firstName
      this.familyNameKana = options.customer.familyNameKana
      this.firstNameKana = options.customer.firstNameKana
      this.customerNote = options.customer.note
    },
  },
  data() {
    return this.defaultData()
  },
  computed: {
    sortedStaffs () {
      let ret = this.staffs.concat()
      ret.sort((a, b) => {
        if (a.shop !== b.shop) {
          if (a.shop === this.shop.pk) {
            return -1
          } else if (b.shop === this.shop.pk) {
            return 1
          } else {
            return a.shopCode < b.shopCode ? -1 : 1
          }
        }
        return a.code < b.code ? -1 : 1
      })
      return ret
    },
    restrictReserveTime () {
      if (this.loggedInAccount.username === 'call') {
        return true
      }
      if (!this.shop.restrictReserveTime) {
        return false
      }
      if (!this.startAt) {
        return false
      }

      const gracePeriod = this.shop.restrictGracePeriod || 0

      if (moment().startOf('date').diff(moment(this.startAt), 'days') >= -gracePeriod) {
        return false
      }
      if (this.shop.restrictStartDate) {
        if (moment(this.startAt).isBefore(this.shop.restrictStartDate, 'date')) {
          return false
        }
      }
      return true
    },
    historyInputEnable() {
      return !!this.crmUuid
    },
    createdAtStr () {
      if (!this.createdAt) {
        return null
      }
      return moment(this.createdAt).format('YYYY年MM月DD日 HH時mm分')
    },
    statusOptions() {
      return ReservationStatus.options
    },
    reservedByMaster() {
      return ReservedBy
    },
    reservedByOptions() {
      return ReservedBy.options
    },
    dyestuffOptions() {
      return this.dyestuffs.map(dyestuff => {
        return {id: dyestuff.pk, text: dyestuff.name}
      })
    },
    startDate: {
      get() {
        return moment(this.startAt).format('YYYY-MM-DD')
      },
      set(val) {
        let t = moment(val, 'YYYY-MM-DD')
        this.startAt = moment(this.startAt).set({
          'year': t.year(),
          'month': t.month(),
          'date': t.date()
        }).toISOString()
      }
    },
    startTime: {
      get() {
        return moment(this.startAt).format('HH:mm')
      },
      set(val) {
        let t = moment(val, 'HH:mm')
        this.startAt = moment(this.startAt).set({'hour': t.hour(), 'minute': t.minute()}).toISOString()
      }
    },
    openTime() {
      return moment(this.businessHour.openAt).format('HH:mm')
    },
    closeTime() {
      return moment(this.businessHour.closeAt).format('HH:mm')
    },
    nonFieldErrors() {
      if (this.errorResponse && this.errorResponse.body.nonFieldErrors) {
        return this.errorResponse.body.nonFieldErrors
      } else {
        return []
      }
    },
    fieldErrors() {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}
      let ec = e.customer

      Object.assign(errors, {
        startAt: e.startAt ? e.startAt : [],
        status: e.status ? e.status : [],
        menu: e.menu ? e.menu : [],
        menuOptions: e.menuOptions ? e.menuOptions : [],
        reservedBy: e.reservedBy ? e.reservedBy : [],
        respondingStaff: e.respondingStaff ? e.respondingStaff : [],
        respondingShampooStaff: e.respondingShampooStaff ? e.respondingShampooStaff : [],
        attendedStaff: e.attendedStaff ? e.attendedStaff : [],
        treatmentStaff: e.treatmentStaff ? e.treatmentStaff : [],
        counselingStaff: e.counselingStaff ? e.counselingStaff : [],
        shampooStaff: e.shampooStaff ? e.shampooStaff : [],
        dyeingStaff_1: e.dyeingStaff_1 ? e.dyeingStaff_1 : [],
        dyeingStaff_2: e.dyeingStaff_2 ? e.dyeingStaff_2 : [],
        note: e.note ? e.note : [],
        isRepeatInMonth: e.isRepeatInMonth ? e.isRepeatInMonth : [],

        account: ec && ec.account ? ec.account : [],
        phoneNumber: ec && ec.phoneNumber ? ec.phoneNumber : [],
        familyNameKana: ec && ec.familyNameKana ? ec.familyNameKana : [],
        firstNameKana: ec && ec.firstNameKana ? ec.firstNameKana : [],
        familyName: ec && ec.familyName ? ec.familyName : [],
        firstName: ec && ec.firstName ? ec.firstName : [],
      })

      return errors
    },
    cleanUsedDyestuffsForRoots() {
      return this.usedDyestuffsForRoots.filter(ud => ud.amount && ud.dyestuff)
    },
    cleanUsedDyestuffsForEnds() {
      return this.usedDyestuffsForEnds.filter(ud => ud.amount && ud.dyestuff)
    },
    cleanUsedSolutionsForRoots() {
      return this.usedSolutionsForRoots.filter(ud => !!ud.amount && !!ud.percentage)
    },
    cleanUsedSolutionsForEnds() {
      return this.usedSolutionsForEnds.filter(ud => !!ud.amount && !!ud.percentage)
    },
    shopsWithoutGroup () {
      let result = []
      this.shops.forEach(v => {
        if (v.shopType === 2) {
          return true
        }
        result.push(v)
      })
      return result
    },
    shortAccount: {
      get() {
        // if (this.account && this.account.length > 6) {
        //   let account = this.account
        //   this.shops.forEach(v => {
        //     if (v.shopType === 2) {
        //       return true
        //     }
        //     if (account.startsWith(v.code)) {
        //       account = account.slice(v.code.length)
        //       return false
        //     }
        //   })
        //   return account
        // } else {
        //   return this.account
        // }
        return this.account
      },
      set(val) {
        if (val) {
          this.account = val.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
          })
        } else {
          this.account = ''
        }
      }
    },
    firstNameKanaInput: {
      get() {
        return this.firstNameKana
      },
      set(val) {
        this.firstNameKana = this.hiraganaToKatakana(val)
      },
    },
    familyNameKanaInput: {
      get() {
        return this.familyNameKana
      },
      set(val) {
        this.familyNameKana = this.hiraganaToKatakana(val)
      },
    },
    shortAccountPrefixShopName () {
      if (!this.shortAccountPrefix) {
        return '-'
      }
      let ret = ''
      this.shops.forEach(v => {
        if (v.code == this.shortAccountPrefix) {
          ret = v.name
          return false
        }
      })
      return ret
    },
    sortedOldOperationHistories () {
      return this.oldOperationHistories.sort((a, b) => {
        let tmp_a = moment(a.date)
        let tmp_b = moment(b.date)
        return tmp_a > tmp_b ? -1 : 1
      })
    },
    isAvailableStaff () {
      if (!this.respondingStaff) {
        return false
      }
      return this.availableStaffs.find(x => x.pk === this.respondingStaff.pk)
    },
    availableStaffs () {
      if (this.availabilities === undefined || this.availabilities.length === 0) {
        return []
      }
      const startAt = moment(moment(this.startAt).format('YYYY-MM-DD HH:mm'))
      const target = this.availabilities.find(x => startAt.isSame(x.datetime))
      if (!target) {
        return []
      }
      const availableStaffs = (this.menu.name.match('/ロング/') ? target.longStaffs : target.shortStaffs)
      if (!availableStaffs) {
        return []
      }

      return this.sortedStaffs.filter(staff => availableStaffs.includes(staff.code))
    },
    unavailableStaffs () {
      const tmp = this.availableStaffs.map(x => x.code)
      return this.sortedStaffs.filter(staff => !tmp.includes(staff.code))
    },
  },
  methods: {
    checkDigit(arr, idx) {
      console.log(JSON.stringify(arr), idx)
      if (!String(arr[idx].amount).match(/^[0-9]*$/)) {
        alert('薬剤は半角数値で入力してください。')
        arr[idx].amount = ''
      }
    },
    checkOver(arr) {
      if (arr.map(x => Number(x.amount)).reduce((a, b) => a + b, 0) > 100) {
        confirm('使用グラム数は合っていますか？')
      }
    },
    defaultData() {
      return {
        isSending: false,

        // 予約情報
        reservationPk: null,
        startAt: this.createAt,
        status: ReservationStatus.NEW,
        menu: null,
        menuOptions: [],
        reservedBy: null,
        attendedStaff: null,
        respondingStaff: null,
        respondingShampooStaff: null,
        note: '',
        isRepeatInMonth: false,
        isRemoved: false,
        hotpepperReservationNo: null,
        hotpepperPoint: null,
        createdAt: null,

        // 顧客情報
        account: null,
        shortAccountPrefix: this.shop.code,
        crmUuid: null,
        phoneNumber: null,
        familyNameKana: null,
        firstNameKana: null,
        familyName: null,
        firstName: null,
        customerNote: null,

        // 施術履歴
        usedDyestuffsForRoots: [this.defaultUsedDyestuff()],
        usedDyestuffsForEnds: [this.defaultUsedDyestuff()],
        usedSolutionsForRoots: [this.defaultUsedSolution()],
        usedSolutionsForEnds: [this.defaultUsedSolution()],
        scalpProtectiveAgent: 0,
        treatment: 0,
        treatmentStaff: null,
        counselingStaff: null,
        shampooStaff: null,
        dyeingStaff_1: null,
        dyeingStaff_2: null,
        operationNote: '',
        lastOperationHistory: null,
        operationHistories: [],
        oldOperationHistories: [],

        activeTab: 0,
        errorResponse: null,
        formLabels: {
          startAt: '来店日時',
          status: 'ステータス',
          menu: 'メニュー',
          menuOptions: 'メニューオプション',
          reservedBy: '予約経路',
          attendedStaff: '予約対応スタッフ',
          respondingStaff: '施術予定スタッフ',
          respondingShampooStaff: 'シャンプー予定スタッフ',
          treatmentStaff: '施術対応',
          counselingStaff: 'カウンセリング',
          shampooStaff: 'シャンプー対応',
          dyeingStaff_1: '塗布対応１',
          dyeingStaff_2: '塗布対応２',
          note: '備考',
          isRepeatInMonth: '30日以内の再来店',

          account: 'お客さま番号',
          phoneNumber: '電話番号',
          nameKana: '氏名(カナ)',
          familyNameKana: '姓(カナ)',
          firstNameKana: '名(カナ)',
          name: '氏名',
          familyName: '姓',
          firstName: '名',
        },
      }
    },
    defaultUsedDyestuff() {
      return {amount: null, dyestuff: ''}
    },
    defaultUsedSolution() {
      return { amount: null, percentage: null }
    },
    copyLastUsedDyestuffs() {
      if (!this.lastOperationHistory) {
        return
      }

      this.usedDyestuffsForRoots = this.lastOperationHistory.usedDyestuffsForRoots
      this.usedDyestuffsForEnds = this.lastOperationHistory.usedDyestuffsForEnds
      this.usedSolutionsForRoots = this.lastOperationHistory.usedSolutionsForRoots
      this.usedSolutionsForEnds = this.lastOperationHistory.usedSolutionsForEnds
    },
    reset() {
      let data = this.defaultData()
      Object.keys(data).forEach(k => this[k] = data[k])
      if (this.loggedInAccount.username === 'call') {
        this.reservedBy = this.reservedByMaster.CALLCENTER
      }
    },
    remove() {
      this.$dispatch('switch-modal', 'remove')
    },
    findCustomer() {
      this.$dispatch('switch-modal', 'customer-finder', [
        {
          name: 'find',
          options: {
            account: this.shortAccount,
            phone_number: this.phoneNumber,
            family_name_kana: this.familyNameKana,
            first_name_kana: this.firstNameKana,
            family_name: this.familyName,
            first_name: this.firstName,
          }
        }
      ])
    },
    restore() {
      this.isSending = true
      return this.apiPut(
        `/api/1.0/reservations/${this.reservationPk}/`,
        {isRemoved: false},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.$dispatch('reservation-updated', response.body.data)
      }).finally(() => {
        this.isSending = false
      })
    },
    submit() {
      let reservation = this.constructReservation()
      this.isSending = true
      if (this.reservationPk) {
        return this.apiPut(
          `/api/1.0/reservations/${this.reservationPk}/`,
          reservation,
          {shopAs: this.shop.pk}
        ).then(response => {
          this.$dispatch('reservation-updated', response.body.data)
        }).catch(reason => {
          if (reason.error.status == 400) {
            this.errorResponse = reason.response
          }
          return Promise.reject(reason)
        }).finally(() => {
          this.isSending = false
        })
      } else {
        return this.apiPost(
          `/api/1.0/reservations/`,
          reservation,
          {shopAs: this.shop.pk}
        ).then(response => {
          this.$dispatch('reservation-created', response.body.data)
        }).catch(reason => {
          if (reason.error.status == 400) {
            this.errorResponse = reason.response
          }
          return Promise.reject(reason)
        }).finally(() => {
          this.isSending = false
        })
      }
    },
    assignReservation(reservation) {
      if (!reservation) {
        return
      }

      // 予約情報
      this.reservationPk = reservation.pk
      this.createdAt = reservation.createdAt
      this.startAt = reservation.startAt
      this.status = reservation.status
      this.menu = this.menus.find(m => m.pk == reservation.menu)
      this.menuOptions = this.menu._embedded.options.filter(o => reservation.menuOptions.includes(o.pk))
      this.reservedBy = reservation.reservedBy
      this.attendedStaff = this.staffs.find(s => s.pk == reservation.attendedStaff)
      this.respondingStaff = this.staffs.find(s => s.pk == reservation.respondingStaff)
      this.respondingShampooStaff = this.staffs.find(s => s.pk == reservation.respondingShampooStaff)
      this.note = reservation.note
      this.isRepeatInMonth = reservation.isRepeatInMonth
      this.isRemoved = reservation.isRemoved
      this.hotpepperReservationNo = reservation.hotpepperReservationNo
      this.hotpepperPoint = reservation.hotpepperPoint

      // 顧客情報
      this.account = reservation.customer.account
      this.shortAccountPrefix = reservation.customer.shopCode || this.shop.code
      /*
         this.shopsWithoutGroup.forEach(v => {
         if (!!this.account && this.account.length > 4 && this.account.startsWith(v.code)) {
         this.shortAccountPrefix = v.code
         return false
         }
         })
       */
      this.crmUuid = reservation.customer.crmUuid
      this.phoneNumber = reservation.customer.phoneNumber
      this.familyNameKana = reservation.customer.familyNameKana
      this.firstNameKana = reservation.customer.firstNameKana
      this.familyName = reservation.customer.familyName
      this.firstName = reservation.customer.firstName
      this.customerNote = reservation.customer.customerNote || reservation.customer.note

      // 施術履歴
      let operationHistory = reservation.operationHistory
      if (operationHistory) {
        if (operationHistory.usedDyestuffsForRoots.length > 0) {
          this.usedDyestuffsForRoots = operationHistory.usedDyestuffsForRoots
        }
        if (operationHistory.usedDyestuffsForEnds.length > 0) {
          this.usedDyestuffsForEnds = operationHistory.usedDyestuffsForEnds
        }
        if (operationHistory.usedSolutionsForRoots.length > 0) {
          this.usedSolutionsForRoots = operationHistory.usedSolutionsForRoots
        }
        if (operationHistory.usedSolutionsForEnds.length > 0) {
          this.usedSolutionsForEnds = operationHistory.usedSolutionsForEnds
        }
        this.scalpProtectiveAgent = operationHistory.scalpProtectiveAgent
        this.treatment = operationHistory.treatment
        this.treatmentStaff = this.staffs.find(s => s.pk == operationHistory.treatmentStaff)
        this.counselingStaff = this.staffs.find(s => s.pk == operationHistory.counselingStaff)
        this.shampooStaff = this.staffs.find(s => s.pk == operationHistory.shampooStaff)
        this.dyeingStaff_1 = this.staffs.find(s => s.pk == operationHistory.dyeingStaff_1)
        this.dyeingStaff_2 = this.staffs.find(s => s.pk == operationHistory.dyeingStaff_2)
        this.operationNote = operationHistory.note
      }
      this.lastOperationHistory = reservation.lastOperationHistory

      this.operationHistories = []
    },
    constructReservation() {
      let reservation = {
        startAt: moment(this.startAt).toISOString(),
        status: this.status,
        menu: this.menu ? this.menu.pk : null,
        menuOptions: this.menuOptions.map(o => o.pk),
        reservedBy: this.reservedBy,
        attendedStaff: this.attendedStaff ? this.attendedStaff.pk : null,
        respondingStaff: this.respondingStaff ? this.respondingStaff.pk : null,
        respondingShampooStaff: this.respondingShampooStaff ? this.respondingShampooStaff.pk : null,
        note: this.note,
        isRepeatInMonth: this.isRepeatInMonth,
        customer: {
          account: this.shortAccount,
          crmUuid: this.crmUuid,
          phoneNumber: this.phoneNumber,
          familyNameKana: this.familyNameKana,
          firstNameKana: this.firstNameKana,
          familyName: this.familyName,
          firstName: this.firstName,
          note: this.customerNote,
        },
      }

      if (
        this.cleanUsedDyestuffsForRoots.length > 0 ||
        this.cleanUsedDyestuffsForEnds.length > 0 ||
        this.cleanUsedSolutionsForRoots.length > 0 ||
        this.cleanUsedSolutionsForEnds.length > 0 ||
        this.scalpProtectiveAgent !== null ||
        this.treatment !== null |
        this.treatmentStaff || this.counselingStaff ||
        this.dyeingStaff_1 || this.dyeingStaff_2 ||
        this.shampooStaff || this.operationNote
      ) {
        reservation.operationHistory = {
          usedDyestuffsForRoots: this.cleanUsedDyestuffsForRoots,
          usedDyestuffsForEnds: this.cleanUsedDyestuffsForEnds,
          usedSolutionsForRoots: this.cleanUsedSolutionsForRoots,
          usedSolutionsForEnds: this.cleanUsedSolutionsForEnds,
          scalpProtectiveAgent: this.scalpProtectiveAgent,
          treatment: this.treatment,
          treatmentStaff: this.treatmentStaff ? this.treatmentStaff.pk : null,
          counselingStaff: this.counselingStaff ? this.counselingStaff.pk : null,
          shampooStaff: this.shampooStaff ? this.shampooStaff.pk : null,
          dyeingStaff_1: this.dyeingStaff_1 ? this.dyeingStaff_1.pk : null,
          dyeingStaff_2: this.dyeingStaff_2 ? this.dyeingStaff_2.pk : null,
          note: this.operationNote
        }
      }

      return reservation
    },
    fetchOperationHistories(crmUuid) {
      if (!crmUuid) {
        return
      }

      return this.apiGet(
        `/api/1.0/customers/${crmUuid}/histories/`,
        {},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.operationHistories = response.body.results
        this.oldOperationHistories = response.body.oldResults
      })
    },
    displayUsedDyestuffs(usedDyestuffs) {
      return usedDyestuffs.map(ud => `${ud._embedded.dyestuff.name}(${ud.amount}g)`).join(',')
    },
    displayUsedSolutions(usedSolutions) {
      return usedSolutions.map(ud => `${ud.percentage}% (${ud.amount}g)`).join(',')
    },
    displayScalpProtectiveAgent(value) {
      let ret = '-';
      switch(value) {
        case 2:
          ret = 'たくさん使った'
          break;
        case 1:
          ret = '使った'
          break;
        case 0:
          ret = '使ってない'
          break;
      }
      return ret
    },
    displayTreatment(value) {
      let ret = '-';
      switch(value) {
        case 1:
          ret = 'さらさら'
          break;
        case 2:
          ret = 'つやさら'
          break;
        case 3:
          ret = 'つやコシ'
          break;
        case 4:
          ret = 'カラーケア'
          break;
      }
      return ret
    },
    hiraganaToKatakana (str) {
      if (!str) {
        return ''
      }
      return str.replace(/[\u3041-\u3096]/g, match => {
        var chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    deleteOperationHistory (pk) {
      if (confirm('この履歴を削除しますか？') === false) {
        return
      }
      this.apiDelete(
        `/api/1.0/operation-histories/${pk}/`,
        {shopAs: this.shop.pk}
      ).then(res => {
        this.fetchOperationHistories(this.crmUuid)
      })
    },
    changeTime () {
      this.$dispatch('show-time-select', this.startAt, this.menu, this.menuOptions, this.reservationPk)
    },
  },
  mixins: [
    require('mixin/api-client.vue'),
    require('mixin/wait.vue'),
  ],
  vuex: {
    getters: {
      loggedInAccount: getAccount,
    },
  },
  components: {
    tabset: require('vue-strap').tabset,
    tab: require('vue-strap').tab,
    datepicker: require('ui/datepicker.vue'),
    timepicker: require('ui/timepicker.vue'),
  },
  filters: {
    blankHyphen (val) {
      if (!val) {
        return '-'
      }
      return val
    },
  },
}
</script>



// WEBPACK FOOTER //
// edit.vue?07f6f38d